import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import TabBarLoader from './TabBarLoader';

/**
 * A wrapper for MUI Tabs component. Styles can be ovridden with sx prop.
 * @param {import('@liquidweb-dev/undercurrent/Box').BoxProps & { dividerProps?: import('@liquidweb-dev/undercurrent/Box').BoxProps, isLoading?: boolean }} props
 */
const TabBar = ({ children, dividerProps, isLoading, sx, ...rest }) => {
	const { sx: dividerSx, ...restDividerProps } = dividerProps || {};

	return (
		<Box
			sx={combineSx(
				{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					position: 'relative',
				},
				sx,
			)}
			{...rest}
		>
			{isLoading ? <TabBarLoader /> : children}
			<Box
				sx={combineSx(
					{
						// divider is semi-transparent, but it would be better
						// to use a color from the UC theme and add opacity
						borderTopColor: 'divider',
						borderTopWidth: '1px',
						borderTopStyle: 'solid',
						bottom: 0,
						left: 0,
						height: '1px',
						position: 'absolute',
						width: '100%',
					},
					dividerSx,
				)}
				{...restDividerProps}
			/>
		</Box>
	);
};

export default TabBar;
